import { Modal, Card, Tabs, Descriptions, Empty, Avatar, Checkbox, Tree } from "antd";
import {
  Tag,
  Tooltip,
  Spin,
  Input,
  Form,
  Flex,
  Divider,
  Button,
  Table,
  Typography,
} from "antd";
import { InputNumber, Radio } from "antd";
import { Component } from "react";
import React from "react";
import { notification, Row, Col, Result } from "antd";
import { Select } from "antd";
import {
  tagsBage,
  tagsBageStatus,
  tagsColorAlert,
  tagsTypeBageColor,
} from "../../helpers/tagsBage";
import {
  calculateTimeDifference,
  FormatTimeAgo,
} from "../../helpers/formatTimeAgo";
import { FormatDataSettleSlipJson } from "../../helpers/formatDataJson";
import {
  CopyOutlined,
  LinkOutlined,
  KeyOutlined,
  UserOutlined,
  DollarOutlined,
  ExportOutlined,
  CheckOutlined,
  CopyTwoTone,
  FilterOutlined,
  HistoryOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { t } from "i18next";
import { CopyTextToClipboard } from "../../helpers/copy";
import { CheckAdminType } from "../../helpers/checkPermission";
import moment from "moment/moment";
import Apiauth from "../../api/Apiauth";
import config from "../../config/app.config";
import imageuser from "../../assets/images/approved.png";
import generateReferenceIdCustomFormat from "../../helpers/generateReferenceIdSimple";
import Apibank from "../../api/Apibank";
import {
  calculateDaysUsed,
  iconBank,
  isEmpty,
  isTokenExpired,
  openNotification,
  scrollToAntSpinContainer,
} from "../../utils";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { getRandomuserParams } from "../../utils";
import Upslip from "../../screens/Deposit/components/Upslip";
import { defaultDataRole } from "../../Data/NavBarData";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { BankData } from "../../Data/BankData";
import { FormatMerchant } from "../../helpers/formatMerchant";
import { MainInfo } from "../../screens/Customer/components/main-Info";
import {
  ColumnsDeposit,
  ColumnsWithdraw,
} from "../../screens/Customer/components/columns";
import { debounce } from "lodash";
import { ModelDetailWithdraw } from "./add-model";
import dayjs from "dayjs";
import { MainSearch } from "../../screens/Customer/components/mainSearch";
import { getAlerIcon, getIcon } from "../../helpers/getIcon";
import { getAllDisplayablePermissionIds, getAllHeaderKeys, getAllHeaderKeysAndGroupKeys, getSelectableTreeData, getViewTreeData, mapPermissionsToCheckedState } from "../../helpers/getTreeData";
const { TextArea } = Input;
const { Text } = Typography;
// ************ Start of DetailModel ************
export class DetailModel extends React.Component {
  createDescriptionsItems = (dataResults, t, dataMerchang) => {
    if (!dataResults) {
      return [];
    }
    // Info
    let formatDate = "YYYY-MM-DD HH:mm:ss";
    let id = dataResults?.id || null;
    let transDateTime = dataResults?.transDateTime || null;
    let customerUuid = dataResults?.customerUuid || null;
    let transRef = dataResults?.transRef || null;
    let payEasyRef = dataResults?.payEasyRef || null;
    let amount = Intl.NumberFormat().format(dataResults?.amount || 0) || null;
    let verifyFee = dataResults?.verifyFee || null;
    let status = dataResults?.status || null;
    let updatedAt = dataResults?.updatedAt || null;
    let createdAt = dataResults?.createdAt || null;
    let note = dataResults?.note || null;
    let merchantId = dataResults?.merchantId || null;
    let admin = dataResults?.Admin?.username || null;

    // sender
    let senderBank = dataResults?.senderBank || null;
    let senderName = dataResults?.senderName || null;
    let senderAccountNo = dataResults?.senderAccountNo || null;

    // receiver
    let receiverBank = dataResults?.receiverBank || null;
    let receiverName = dataResults?.receiverName || null;
    let receiverAccountNo = dataResults?.receiverAccountNo || null;
    // let bankAccountId = dataResults?.bankAccountId || null;

    const copy = (item, txt) => CopyTextToClipboard(item, txt);
    const iconBank = (code) => {
      if (!code) return null;
      let bank = BankData.find((i) => i.bankCode === code);
      if (!bank) return null;
      return { ...bank };
    };
    let merchans = FormatMerchant(dataMerchang, merchantId);
    let name = merchans?.name || null;

    const items = [
      {
        label: t("ID "),
        children: id,
        span: 3,
      },
      // Transaction Date/Time
      {
        label: t("Transaction Date/Time"),
        children: moment(transDateTime).format(formatDate),
        span: 3,
      },
      {
        label: t("merchant"),
        children: name && `${name} (${merchantId})`,
        span: 3,
      },
      // PayEasyRef
      {
        label: t("PayEasyRef"),
        children: (
          <>
            {payEasyRef}
            <Button
              icon={<CopyOutlined />}
              onClick={() => copy(payEasyRef, t("Copied!"))}
              style={{ marginLeft: 8 }}
            />
          </>
        ),
        span: 3,
      },

      // transRef
      {
        label: t("TransRef"),
        children: (
          <>
            {transRef}
            <Button
              icon={<CopyOutlined />}
              onClick={() => copy(transRef, t("Copied!"))}
              style={{ marginLeft: 8 }}
            />
          </>
        ),
        span: 3,
      },

      // customerUuid
      {
        label: t("CustomerUuid"),
        children: (
          <>
            {customerUuid}{" "}
            <Button
              icon={<CopyOutlined />}
              onClick={() => copy(customerUuid, t("Copied!"))}
              style={{ marginLeft: 8 }}
            />
          </>
        ),
        span: 3,
      },

      //senderBank

      {
        label: t("Sender Bank"),
        style: { background: "#84ff3e2b" },
        children: (
          <>
            <img
              src={iconBank(senderBank)?.bankLogo}
              alt="Bank Icon"
              style={{ width: 24, marginRight: 8 }}
            />
            <span>{t(iconBank(senderBank)?.bank_id)}</span>
          </>
        ),
        span: 3,
      },

      // senderName
      {
        label: t("senderName"),
        children: senderName,
        style: { background: "#84ff3e2b" },
        span: 3,
      },

      // senderAccountNo
      {
        label: t("Sender Account No"),
        children: senderAccountNo,
        style: { background: "#84ff3e2b" },
        span: 3,
      },

      // Amount
      {
        label: t("Amount "),
        children: amount,
        span: 3,
      },
      // verifyFee
      {
        label: t("verifyFee"),
        children:
          status === "MATCHED" || status === "SUCCESS" ? verifyFee : "-",
        span: 3,
      },

      // Admin
      {
        label: t("ทำรายการโดย"),
        children: admin,
        span: 3,
      },

      // Status
      {
        label: t("Status"),
        children: <Tag color={tagsBageStatus(status)}>{status}</Tag>,
        span: 3,
      },

      //note
      {
        label: t("note"),
        children: note,
        span: 3,
      },

      // ReceiverBank
      {
        label: t("ReceiverBank"),
        style: { background: "#3eacff33" },
        children: (
          <>
            <img
              src={iconBank(receiverBank)?.bankLogo}
              alt="Bank Icon"
              style={{ width: 24, marginRight: 8 }}
            />
            <span>{t(iconBank(receiverBank)?.bank_id)}</span>
          </>
        ),
        span: 3,
      },

      //ReceiverName
      {
        label: t("ReceiverName"),
        style: { background: "#3eacff33" },
        children: receiverName,
        span: 3,
      },

      // receiverAccountNo
      {
        label: t("ReceiverAccountNo"),
        style: { background: "#3eacff33" },
        children: receiverAccountNo,
        span: 3,
      },

      //createdAt
      {
        label: t("createdAt"),
        children: moment(createdAt).format(formatDate),
        span: 3,
      },

      //updatedAt
      {
        label: t("updatedAt"),
        children: moment(updatedAt).format(formatDate),
        span: 3,
      },
    ];

    return items.filter(
      (item) => item.children !== null && item.children !== undefined,
    );
  };
  render() {
    const { isData, show, handleClose, t, resAllDataMerchang } = this.props;

    let dataResults = isData || null;

    if (dataResults || show) {
      const items = this.createDescriptionsItems(
        dataResults,
        t,
        resAllDataMerchang,
      );

      return (
        <>
          <Modal
            title={t("detail verifyslip-transactions")}
            open={show}
            onOk={handleClose}
            onCancel={handleClose}
            confirmLoading={false}
            centered={false}
            style={{ top: 20 }}
            maskClosable={false}
            width={800}
            cancelText="ปิด"
          >
            <>
              <br />
              <Descriptions bordered items={items} />
            </>
          </Modal>
        </>
      );
    }

    return null;
  }
}

// ************ End of DetailModel ************

// ************ Start of DetailModelCustomer ************
export class DetailModelCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataType: "deposit",
      dataStatus: "",
      startDate: dayjs(moment().format("YYYY-MM-DD")),
      startDateTitle: null,
      endDate: dayjs(moment().format("YYYY-MM-DD")),
      endDateTitle: null,
      showDetailsModel: false,
      searchText: "",
      typeSearch: "refUuid",
      isDataInfo: null,
      showDetailsModelWithdraw: false,
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
      dataTable: [],
      loading: false,
      isMobile: window.innerWidth <= 768,
    };
    this.fetchTransactionData = this.fetchTransactionData.bind(this);
    // สร้าง debounced function
    this.debouncedSearch = debounce(this.fetchTransactionData, 100);
  }

  componentDidMount() {
    // 💡 แก้ไข: เพิ่ม event listener สำหรับ resize
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    // ทำความสะอาด debounce เพื่อป้องกัน memory leaks
    this.debouncedSearch.cancel();
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleChange = (key, value) => {
    this.setState(
      (prevState) => ({
        [key]: value,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            current: 1,
            pageSize: 5,
            total: 0,
          },
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedSearch();
      },
    );
  };

  handleSelectTypeSearch = (key, value) => {
    this.setState(
      (prevState) => ({
        [key]: value,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            current: 1,
            pageSize: 5,
            total: 0,
          },
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedSearch();
      },
    );
  };

  handleDateRangeChange = (dates) => {
    this.setState(
      {
        startDate: dates ? dates[0] : null,
        endDate: dates ? dates[1] : null,
        startDateTitle: dates ? dates[0] : null,
        endDateTitle: dates ? dates[1] : null,
      },
      () => this.debouncedSearch(),
    );
  };

  fetchTransactionData = async () => {
    const { dataType, dataStatus, startDate, endDate, searchText, typeSearch } =
      this.state;
    const { isData, showToast } = this.props;
    const { tableParams } = this.state;
    const { startDateTitle, endDateTitle } = this.state;
    let titleDate = document.getElementById("date");
    const params = getRandomuserParams(tableParams);
    let item = {
      customer_uuid: isData?.customer_uuid,
      type: dataType,
      status: dataStatus,
      startDate: startDate ? startDate.format("YYYY-MM-DD") : null,
      endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
      search: searchText,
      typeSearch: searchText !== "" ? typeSearch : "",
      limit: params.limit,
      page: params.page,
    };

    if (!item.customer_uuid) {
      return;
    }

    this.setState({ loading: true });

    try {
      const res = await Apiauth.searchTransaction(item);
      if (res.status === 200) {
        if (titleDate && startDateTitle && endDateTitle) {
          const start = startDateTitle.format("YYYY-MM-DD");
          const end = endDateTitle.format("YYYY-MM-DD");
          titleDate.innerText = `${t("Date")} ${start} - ${end}`;
        } else if (titleDate) {
          const start = startDate ? startDate.format("YYYY-MM-DD") : "";
          const end = endDate ? endDate.format("YYYY-MM-DD") : "";
          titleDate.innerText = `${t("Date")} ${start} - ${end}`;
        }

        const fetchedData = Array.isArray(res.data.data_transactions)
          ? res.data.data_transactions
          : [];

        this.setState((prevState) => ({
          dataTable: fetchedData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total: res.data.totalItems,
              current: tableParams.pagination.current,
              pageSize: tableParams.pagination.pageSize,
            },
          },
          loading: false,
        }));
      } else {
        showToast("error", res.message || "Failed to fetch data.");
        this.setState({ loading: false, dataTable: [] });
      }
    } catch (error) {
      console.error("Error fetching transaction data:", error);
      showToast("error", error.message || "Failed to fetch data.");
      this.setState({ loading: false, dataTable: [] });
    }
  };

  handleCloseModels = () => {
    this.setState({
      showDetailsModel: false,
      showDetailsModelWithdraw: false,
      isDataInfo: null,
    });
  };

  onClose = () => {
    const { handleClose } = this.props;
    this.setState((prevState) => ({
      showDetailsModel: false,
      dataType: "deposit",
      dataStatus: "",
      isDataInfo: null,
      showDetailsModelWithdraw: false,
      dataTable: null,
      startDate: dayjs(moment().format("YYYY-MM-DD")),
      endDate: dayjs(moment().format("YYYY-MM-DD")),
      startDateTitle: null,
      endDateTitle: null,
      tableParams: {
        ...prevState.tableParams,
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
        },
      },
    }));
    handleClose();
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      (prevState) => ({
        loading: true,
        tableParams: {
          ...prevState.tableParams,
          pagination,
          filters,
          sortField: sorter.field,
          sortOrder: sorter.order,
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        this.debouncedSearch();
      },
    );
  };

  render() {
    const {
      isData,
      show,
      activeTabKey1,
      allBankAccountData,
      resAllDataMerchang,
      nameMerchang,
      t,
      showToast,
    } = this.props;
    let data = isData || null;
    const {
      loading,
      dataTable,
      tableParams,
      showDetailsModel,
      isDataInfo,
      showDetailsModelWithdraw,
      dataType,
      startDate,
      endDate,
      typeSearch,
      dataStatus,
    } = this.state;
    const handleShowDetails = (key) => {
      if (!key) {
        showToast("error", t("Invalid data."));
        return;
      }
      if (key === "Not allowed") {
        return alert(
          `!You are not authorized to view or take any action on any other store.`,
        );
      }
      this.setState(
        {
          isDataInfo: key,
        },
        () => {
          if (dataType === "deposit") {
            this.setState({
              showDetailsModel: true,
            });
          }
          if (dataType === "withdraw") {
            this.setState({
              showDetailsModelWithdraw: true,
            });
          }
        },
      );
    };
    const columnsDeposit = ColumnsDeposit(t, handleShowDetails, tableParams);
    const columnsWithdraw = ColumnsWithdraw(
      t,
      handleShowDetails,
      tableParams,
    );

    if (!show) {
      return null;
    }
    return (
      <>
        <PayinDetailsModel
          handleClose={this.handleCloseModels}
          allBankAccountData={allBankAccountData}
          isData={isDataInfo}
          show={showDetailsModel}
          type={activeTabKey1}
          t={t}
        />
        <ModelDetailWithdraw
          handleClose={this.handleCloseModels}
          isData={isDataInfo}
          show={showDetailsModelWithdraw}
          title={t("Withdrawal")}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />
        <Modal
          title={t("Customer's Detail")}
          open={show}
          onCancel={this.onClose}
          maskClosable={false}
          confirmLoading={false}
          centered={false}
          style={{ top: 20 }}
          width={1000}
          footer={[<Button onClick={this.onClose}>{t("close")}</Button>]}
        >
          <br />
          <div>
            <div className="body">
              <div className="media">
                {/* Avarta */}
                <div className="media-left m-r-15">
                  <img
                    alt="User"
                    width={80}
                    className="user-photo media-object"
                    src={imageuser}
                  />
                </div>

                {/* main-Info */}
                <MainInfo data={data} t={t} />
              </div>
            </div>
            <div className="body">
              <Divider style={{ fontSize: 14, color: "#888", fontWeight: "400" }}
                orientation="left"
                orientationMargin="0">
                <FilterOutlined /> {" "} {t("filters")}
              </Divider>
              <div className="row clearfix">
                {/*  */}
                <MainSearch
                  t={t}
                  handleChange={this.handleChange}
                  handleSelectTypeSearch={this.handleSelectTypeSearch}
                  handleDateRangeChange={this.handleDateRangeChange}
                  startDate={startDate}
                  endDate={endDate}
                  typeSearch={typeSearch}
                  dataStatus={dataStatus}
                  dataType={dataType}
                />
                {/* Table */}
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <Divider
                    style={{ fontSize: 14, color: "#888", fontWeight: "400" }}
                    orientation="left"
                    orientationMargin="0"
                  >
                    <HistoryOutlined /> {" "} {t(dataType)}{" "}
                    <span id="date"></span>{" "}
                    <span>: ({tableParams.pagination.total} {t("entries")})</span>
                  </Divider>
                  <div className="form-group table-responsive">
                    <Table
                      columns={
                        dataType === "deposit"
                          ? columnsDeposit
                          : columnsWithdraw
                      }
                      locale={{
                        emptyText: (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={t("No data")}
                          />
                        ),
                      }}
                      dataSource={dataTable}
                      loading={loading}
                      rowKey={(record) => record.id}
                      onChange={this.handleTableChange}
                      pagination={{
                        ...tableParams.pagination,
                        showSizeChanger: true,
                        locale: {
                          items_per_page: `/ ${t("paged")}`,
                        },
                        showTotal: (total, range) => {
                          // คำนวณหน้าปัจจุบัน
                          const currentPage = tableParams.pagination.current;
                          // คำนวณจำนวนหน้าทั้งหมด
                          const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                          return (
                            <span>
                              {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                              <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                              <span style={{ marginLeft: 10 }}>
                                {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                              </span>
                            </span>
                          );
                        },
                      }}
                      scroll={{ x: "max-content" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Divider orientation="center">
            <small style={{ fontSize: "11px", color: "#888" }}>
              Version: {config.version}
            </small>
          </Divider>
        </Modal>
      </>
    );
  }
}
// ************ End of DetailModelCustomer **************

// ************ Start of DetailRoleModel ************

export class DetailRoleModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      permissionsData: [],
      dataRole: [],
      loading: false,
      expandedKeys: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // เมื่อเปลี่ยน Tab มาที่ Permission ให้คำนวณการกาง Tree
    if (prevState.activeTabKey1 !== this.state.activeTabKey1 && this.state.activeTabKey1 === "tab2") {
      this.initExpandedKeys();
    }
  }

  onTab1Change = (key) => {
    const { isData, roleData } = this.props;
    this.setState({ activeTabKey1: key, dataRole: roleData }, () =>
      this.handleOnSelectChange(isData.name),
    );
  };

  handleOnSelectChange = (isRole) => {
    const { dataRole } = this.state;
    this.setState({ loading: true });
    let filterRole = dataRole.find((role) => role.name === isRole);

    if (!filterRole) {
      // showToast("error", this.props.t("Role not found."));
      this.setState({ loading: false });
      return;
    }

    this.setState({
      permissionsData: filterRole?.permission || []
    }, () => {
      this.setState({ loading: false });
      if (this.state.activeTabKey1 === "tab2") this.initExpandedKeys();
    });
  };

  // คำนวณหาหัวข้อที่มีสิทธิ์อยู่ เพื่อกาง Tree ออกโชว์
  initExpandedKeys = () => {
    const { permissionsData } = this.state;
    if (!permissionsData || permissionsData.length === 0) return;

    const newExpandedKeys = [];
    permissionsData.forEach(item => {
      if (item.isPublic === 1) {
        const resKey = `resource-${item.resource}`;
        const actKey = `action-group-${item.resource}`;
        if (!newExpandedKeys.includes(resKey)) newExpandedKeys.push(resKey);
        if (item.action === "action" && !newExpandedKeys.includes(actKey)) {
          newExpandedKeys.push(actKey);
        }
      }
    });
    this.setState({ expandedKeys: newExpandedKeys });
  };

  getTreeData = () => {
    const { permissionsData } = this.state;
    const { t } = this.props;

    if (!Array.isArray(permissionsData) || permissionsData.length === 0) return [];

    // ดึงเฉพาะตัวที่มีสิทธิ์ (isPublic === 1) และเป็น public data
    const activePermissions = permissionsData.filter(item => item.isPublic === 1 && item.ispublic === true);
    const resources = [...new Set(activePermissions.map(item => item.resource))];

    return resources.map(resource => {
      const items = activePermissions.filter(item => item.resource === resource);
      const normalItems = items.filter(item => item.action !== "action");
      const actionItems = items.filter(item => item.action === "action");
      const children = [];

      normalItems.forEach(item => {
        children.push({
          title: t(item.description) || item.name,
          key: `perm-${item.permissionId || item.id}`,
          isLeaf: true
        });
      });

      if (actionItems.length > 0) {
        children.push({
          title: <span className="font-bold text-blue-600">{t("action")}</span>,
          key: `action-group-${resource}`,
          children: actionItems.map(item => ({
            title: t(item.description) || item.name,
            key: `perm-${item.permissionId || item.id}`,
            isLeaf: true
          }))
        });
      }

      return {
        title: <span className="font-bold text-lg">{t(resource)}</span>,
        key: `resource-${resource}`,
        children: children
      };
    });
  };

  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };

  onClose = () => {
    const { handleClose } = this.props;
    this.setState({ activeTabKey1: "tab1", expandedKeys: [] }, () => handleClose());
  };

  render() {
    const { show, isData, nameMerchang, t } = this.props;
    const { activeTabKey1, expandedKeys, permissionsData } = this.state;

    if (!show) return null;

    const treeData = getViewTreeData(permissionsData, t);

    const tabList = [
      { key: "tab1", tab: t("Details") },
      { key: "tab2", tab: t("Permission Info") },
    ];

    const contentList = {
      tab1: (
        <div className="table-responsive mt-3">
          <table className="table table-hover" style={{ border: "none" }}>
            <tbody style={{ border: "none" }}>
              <tr style={{ border: "none" }}>
                <td style={{ border: "none" }}><strong>{t("UUID")}</strong></td>
                <td className="text-right text-primary" style={{ border: "none" }}>
                  {isData?.UUID || "-"}
                  <CopyOutlined
                    className="ml-2 cursor-pointer"
                    onClick={() => CopyTextToClipboard(isData?.UUID)}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ border: "none" }}><strong>{t("Merchant name")}</strong></td>
                <td style={{ border: "none" }} className="text-right">{nameMerchang || "-"}</td>
              </tr>
              <tr>
                <td style={{ border: "none" }}><strong>{t("Merchant ID")}</strong></td>
                <td style={{ border: "none" }} className="text-right">{isData?.merchantId || "-"}</td>
              </tr>
              <tr>
                <td style={{ border: "none" }}><strong>{t("Roles")}</strong></td>
                <td style={{ border: "none" }} className="text-right">
                  <Tag color={tagsBage(isData?.name)}>{isData?.name || "-"}</Tag>
                </td>
              </tr>
              <tr>
                <td style={{ border: "none" }}><strong>{t("Role Name")}</strong></td>
                <td style={{ border: "none" }} className="text-right">{isData?.roleName}</td>
              </tr>
              <tr>
                <td style={{ border: "none" }}><strong>{t("createdAt")}</strong></td>
                <td style={{ border: "none" }} className="text-right">
                  <Tooltip title={moment(isData?.createdAt).format("YYYY-MM-DD HH:mm:ss")}>
                    <span className="text-primary">{FormatTimeAgo(isData?.createdAt) || "-"}</span>
                  </Tooltip>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
      tab2: (
        <div className="p-2">
          <h5 className="mb-4">
            {t("Permissions list for")} <Tag color={tagsBage(isData?.name)}>{isData?.name || "-"}</Tag>
          </h5>
          <div className="permissions-container p-3 rounded-md bg-gray-50" style={{ maxHeight: '450px', overflowY: 'auto', }}>
            {treeData.length > 0 ? (
              <Tree
                showLine={{ showLeafIcon: false }}
                switcherIcon={<CaretDownOutlined />}
                showIcon
                treeData={treeData}
                expandedKeys={expandedKeys}
                onExpand={this.onExpand}
                selectable={false}
                blockNode
              />
            ) : (
              <Empty description={t("No permissions data available.")} />
            )}
          </div>
        </div>
      ),
    };

    return (
      <Modal
        title={t("รายละเอียดตำแหน่ง")}
        maskClosable={false}
        open={show}
        onCancel={this.onClose}
        style={{ top: 20 }}
        width={800}
        footer={[<Button key="close" onClick={this.onClose}>{t("close")}</Button>]}
      >
        <Card
          style={{ width: "100%", border: "none", background: "transparent", boxShadow: "none", padding: "10px 0" }}
          tabList={tabList}
          activeTabKey={activeTabKey1}
          onTabChange={this.onTab1Change}
        >
          {isData ? contentList[activeTabKey1] : <p>{t("Loading role data...")}</p>}
          <Divider orientation="center">
            <small style={{ fontSize: "11px", color: "#888" }}>Version: {config.version}</small>
          </Divider>
        </Card>
      </Modal>
    );
  }
}
// ************ End of DetailRoleModel ************

// ************ Start of ModelEditRoles ************

export class ModelEditRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: this.props.isLoad || false,
      handleInput: {
        name: this.props.isData?.name || "",
        role_name: this.props.isData?.roleName || "",
        roleId: this.props.isData?.id || null,
      },
      handleChecked: mapPermissionsToCheckedState(this.props.isData?.permission),
      expandedKeys: [], // เก็บสถานะการกางของ Tree
    };
    this.onChangePermission = this.onChangePermission.bind(this);
    this.debouncedFetchPermission = debounce(this.onChangePermission, 1000);
  }

  componentDidMount() {
    if (this.props.isData) {
      this.initExpandedKeys();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isData !== prevProps.isData && this.props.isData) {
      this.setState({
        handleInput: {
          name: this.props.isData.name || "",
          role_name: this.props.isData.roleName || "",
          roleId: this.props.isData.id || null,
        },
        handleChecked: mapPermissionsToCheckedState(this.props.isData.permission),
      }, () => {
        this.initExpandedKeys();
      });
    }
  }

  // คำนวณหาหัวข้อที่ควรจะกางออก (เฉพาะที่มีสิทธิ์ถูกเลือกอยู่)
  initExpandedKeys = () => {
    const { permissionAll } = this.props;
    const { handleChecked } = this.state;
    if (!permissionAll || !handleChecked) return;

    const newExpandedKeys = [];
    const checkedIds = Object.keys(handleChecked).filter(id => handleChecked[id] === true).map(Number);

    permissionAll.forEach(item => {
      if (checkedIds.includes(parseInt(item.id))) {
        const resKey = `resource-${item.resource}`;
        const actKey = `action-group-${item.resource}`;
        if (!newExpandedKeys.includes(resKey)) newExpandedKeys.push(resKey);
        if (item.action === "action" && !newExpandedKeys.includes(actKey)) {
          newExpandedKeys.push(actKey);
        }
      }
    });
    this.setState({ expandedKeys: newExpandedKeys });
  };

  handleOnchange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      handleInput: { ...prevState.handleInput, [name]: value },
    }));
  };

  togglePermission = async (permissionId, isPublic) => {
    const { isData, showToast, t } = this.props;
    if (!isData?.id) return;

    this.setState({ isLoad: true });
    try {
      const res = await Apiauth.editPermission({
        permissionId: permissionId,
        roleId: isData.id,
        isPublic: isPublic ? 1 : 0,
      });

      if (res.data.success) {
        showToast("success", res.data.message);
        this.setState((prevState) => ({
          handleChecked: { ...prevState.handleChecked, [permissionId]: isPublic },
        }));
        this.debouncedFetchPermission();
      } else {
        showToast("error", res.data.message || t("Failed to update permission."));
      }
    } catch (err) {
      showToast("error", err.message || t("An error occurred."));
    } finally {
      this.setState({ isLoad: false });
    }
  };

  onChangePermission = () => {
    const { fetchData, fetchPromiseData } = this.props;
    if (fetchData) fetchData();
    if (fetchPromiseData) fetchPromiseData();
  };

  funOnsubmitEditRole = async () => {
    const { showToast, fetchData } = this.props;
    const { handleInput } = this.state;
    this.setState({ isLoad: true });
    try {
      const res = await Apiauth.editRole({
        name: handleInput.name,
        roleName: handleInput.role_name,
        roleId: handleInput.roleId,
      });
      if (res.data.success) {
        showToast("success", res.data.message);
        fetchData();
      } else {
        showToast("error", res.data.message);
      }
    } catch (err) {
      showToast("error", err.message);
    } finally {
      this.setState({ isLoad: false });
    }
  };

  onCheckTree = (checkedInfo, info) => {
    const clickedKey = info.node.key;
    if (typeof clickedKey === 'number') {
      this.togglePermission(clickedKey, info.checked);
    }
  };

  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };

  render() {
    const { show, isData, handleClose, t, nameMerchang, permissionAll } = this.props;
    const { handleChecked, handleInput, isLoad, expandedKeys } = this.state;

    if (!show || !isData) return null;

    const treeData = getSelectableTreeData(permissionAll, t);
    const checkedKeys = Object.keys(handleChecked).filter(id => handleChecked[id] === true).map(Number);

    return (
      <Modal
        title={t("edit role")}
        onCancel={handleClose}
        maskClosable={false}
        open={show}
        footer={[<Button key="close" onClick={handleClose}>{t("close")}</Button>]}
        style={{ top: 20 }}
        width={800}
      >
        <Spin spinning={isLoad}>
          <Form layout="vertical" onFinish={this.funOnsubmitEditRole}>
            <Row gutter={[21, 27]}>
              <Col xs={24} md={9}>
                <Divider orientation="left" plain><span className="h5">{t("info system")}</span></Divider>
                <Form.Item label={t("Role (system)")}>
                  <Input name="name" value={handleInput?.name} onChange={this.handleOnchange} />
                </Form.Item>
                <Form.Item label={t("Role Name (Custom)")} tooltip={t("The Role name can be changed.")}>
                  <Input name="role_name" value={handleInput?.role_name} onChange={this.handleOnchange} autoFocus />
                </Form.Item>
                <Form.Item label={t("Merchant")}>
                  <Input value={nameMerchang || "Easy Payment"} disabled style={{ cursor: "no-drop" }} />
                </Form.Item>
                <Flex wrap gap="small">
                  <Button onClick={handleClose} danger>{t("cancel")}</Button>
                  <Button type="primary" htmlType="submit" loading={isLoad}>{t("confirm")}</Button>
                </Flex>
              </Col>

              <Col xs={24} md={15}>
                <Divider orientation="left" plain><span className="h5">{t("accessible")}</span></Divider>
                <div className="permissions-container p-3 rounded-md bg-gray-50" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                  {treeData.length > 0 ? (
                    <Tree
                      checkable
                      checkStrictly
                      showLine={{ showLeafIcon: false }}
                      switcherIcon={<CaretDownOutlined />}
                      onCheck={this.onCheckTree}
                      onExpand={this.onExpand}
                      expandedKeys={expandedKeys}
                      checkedKeys={{ checked: checkedKeys }}
                      treeData={treeData}
                      selectable={false}
                      blockNode
                    />
                  ) : (
                    <Empty description={t("No permissions available.")} />
                  )}
                </div>
              </Col>
            </Row>
          </Form>
        </Spin>
        <div style={{ textAlign: "center", marginTop: "20px", color: "#888" }}>
          <p>{t("version")} : {config?.version}</p>
        </div>
      </Modal>
    );
  }
}

// ************ End of ModelEditRoles ************

// ************ Start of AddRole ************

export class AddRole extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      permissionData: null,
      selectedPermissions1: [],
      isAllSelected: false,
      expandedKeys: [], // เพิ่ม state สำหรับควบคุมการกาง Tree
      stateRole: {
        data: [],
      },
    };
  }

  componentDidMount() {
    this.fetchPermissions();
    this.fetchRoles();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissionData !== this.state.permissionData) {
      this.updateIsAllSelectedState();
    }

    if (
      prevState.selectedPermissions1.length !==
      this.state.selectedPermissions1.length
    ) {
      this.updateIsAllSelectedState();
    }
  }



  updateIsAllSelectedState = () => {
    const { selectedPermissions1, permissionData } = this.state;
    const allDisplayableIds = getAllDisplayablePermissionIds(permissionData);

    const allSelected =
      allDisplayableIds.length > 0 &&
      allDisplayableIds.every((id) => selectedPermissions1.includes(id));

    if (this.state.isAllSelected !== allSelected) {
      this.setState({ isAllSelected: allSelected });
    }
  };

  fetchPermissions = async () => {
    try {
      this.setState({ permissionData: this.props.permissionAll }, () => {
        this.updateIsAllSelectedState();
      });
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
      notification.error({
        message: "Error",
        description: this.props.t("Failed to load permissions."),
      });
    }
  };

  fetchRoles = async () => {
    try {
      this.setState({
        stateRole: {
          data: this.props.resDataRole,
        },
      });
    } catch (error) {
      console.error("Failed to fetch roles:", error);
      notification.error({
        message: "Error",
        description: this.props.t("Failed to load roles."),
      });
    }
  };

  handlePermissionChange = (event) => {
    const permissionId = parseInt(event.target.value);
    this.setState((prevState) => {
      const { selectedPermissions1 } = prevState;
      const isChecked = event.target.checked;
      const newPermissions = isChecked
        ? [...selectedPermissions1, permissionId]
        : selectedPermissions1.filter((id) => id !== permissionId);
      return { selectedPermissions1: newPermissions };
    });
  };
  handleSelectAll = (event) => {
    const { permissionData } = this.state;
    const isChecked = event.target.checked;
    const allDisplayableIds = getAllDisplayablePermissionIds(permissionData);
    const allHeaderKeys = getAllHeaderKeysAndGroupKeys(permissionData);

    this.setState({
      isAllSelected: isChecked,
      selectedPermissions1: isChecked ? allDisplayableIds : [],
      expandedKeys: isChecked ? allHeaderKeys : [],
    });
  };

  funOnsubmitAddRole = async (values) => {
    const { selectedPermissions1 } = this.state;
    const { isMerchantData } = this.props;
    let merchantInfo = isMerchantData;

    if (selectedPermissions1.length === 0) {
      openNotification(
        "error",
        "เกิดข้อผิดพลาด",
        "คุณต้องเลือก สิทธิ์การเข้าถึง อย่างน้อย 1 สิทธิ์",
      );
      return;
    }

    const data = {
      name: `${values.name}`,
      roleName: values.role_name,
      permission: selectedPermissions1,
      merchantId: merchantInfo?.id,
    };

    this.setState({ loading: true });
    try {
      const res = await Apiauth.addRoles(data);
      if (res.data.success) {
        notification.success({
          message: "Success",
          description: res.data.message,
        });
        setTimeout(() => {
          this.setState(
            {
              loading: false,
              selectedPermissions1: [],
              isAllSelected: false,
              expandedKeys: [],
            },
            () => {
              this.onClose();
            },
          );
        }, 1000);
      } else {
        notification.error({
          message: "Error",
          description: res.data.message,
        });
        setTimeout(() => this.setState({ loading: false }), 1000);
      }
    } catch (err) {
      notification.error({
        message: "Error",
        description:
          err?.response?.data?.message ||
          err.message ||
          this.props.t("An unexpected error occurred."),
      });
      setTimeout(() => this.setState({ loading: false }), 1000);
      console.error("Error adding role:", err);
    }
  };


  onClose = () => {
    const { fetchData, handleClose } = this.props;
    if (this.formRef.current) {
      this.formRef.current?.resetFields();
    }
    this.setState(
      {
        loading: false,
        selectedPermissions1: [],
        isAllSelected: false,
        expandedKeys: [],
      },
      () => {
        fetchData();
        handleClose();
        this.fetchRoles();
      },
    );
  };

  // จัดการเมื่อมีการติ๊กที่ Tree
  onCheckTree = (checkedKeysValue) => {
    // กรองเอาเฉพาะที่เป็นตัวเลข (ID จริงๆ) ไม่เอา Key สมมติของ Group
    const actualKeys = checkedKeysValue.filter(key => typeof key === 'number');
    this.setState({ selectedPermissions1: actualKeys });
  };

  // เพิ่มฟังก์ชันจัดการการกาง/หุบ ด้วยมือ (เผื่อ User กดคลิกที่ลูกศรเอง)
  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };
  render() {
    const { loading, isAllSelected, selectedPermissions1, expandedKeys, permissionData } = this.state;
    const { show, t, nameMerchang, resProfileAdmin } = this.props;
    let isArray = Array.isArray(defaultDataRole);
    let isDefaultDataRole = isArray ? defaultDataRole : [];
    let typeAdmin = ["programer", "superadmin"];
    let roleAdmin = ["Owner", "Subowner"];
    let hidenRole = ["SuperOwner", "Subowner"];

    let type = resProfileAdmin?.admin_type;
    let isRole = resProfileAdmin?.role;
    let mID = resProfileAdmin?.Active_merchantId;
    let accessible = roleAdmin.includes(isRole) || typeAdmin.includes(type);
    const treeData = getSelectableTreeData(permissionData, t);
    return (
      <>
        <Modal
          title={t("add role")}
          onCancel={this.onClose}
          maskClosable={false}
          open={show}
          confirmLoading={false}
          footer={[<Button onClick={this.onClose}>{t("close")}</Button>]}
          centered={false}
          style={{ top: 20 }}
          width={800}
        >
          <Spin spinning={loading} tip={t("Loading...")}>
            <Form
              ref={this.formRef}
              layout="vertical"
              onFinish={this.funOnsubmitAddRole}
            >
              <Row gutter={[21, 27]}>
                {/* ฝั่งซ้าย: ข้อมูลระบบ */}
                <Col xs={24} md={9} className="flex flex-col">
                  <Divider orientation="left" plain>
                    <span className="text-lg font-semibold" style={{ fontWeight: "500" }}>
                      {t("info system")}
                    </span>
                  </Divider>

                  <Form.Item label={t("UUID")} name="uuid">
                    <Input placeholder={t("System Generated")} disabled className="rounded-md" />
                  </Form.Item>

                  <Form.Item
                    label={t("Role (system)")}
                    name="name"
                    rules={[{ required: true, message: t("Please Select Roles Name (system)!") }]}
                  >
                    <Select placeholder={t("Select Role (system)")}>
                      {isDefaultDataRole?.map((item, key) => (
                        accessible || !hidenRole.includes(item?.name) ? (
                          <Select.Option key={key} value={item.name + mID}>
                            {item.roleName}
                          </Select.Option>
                        ) : null
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={t("Role Name (Custom)")}
                    name="role_name"
                    rules={[{ required: true, message: t("Please input the role display name!") }]}
                  >
                    <Input defaultValue={`${nameMerchang} - `} placeholder={t("ตั้งชื่อ Role สำหรับร้านค้าของคุณ")} className="rounded-md" />
                  </Form.Item>

                  <Flex wrap gap="small" className="mt-4">
                    <Button htmlType="reset" danger className="rounded-md">{t("cancel")}</Button>
                    <Button type="primary" htmlType="submit" className="rounded-md">{t("confirm")}</Button>
                  </Flex>
                </Col>

                {/* ฝั่งขวา: สิทธิ์การเข้าถึง */}
                <Col xs={24} md={15}>
                  <Divider orientation="left" plain>
                    <span className="text-lg font-semibold">{t("accessible")}</span>
                  </Divider>

                  <div className="permissions-container p-3 rounded-md bg-gray-50">
                    <div className="mb-2 pb-2 font-bold" style={{ borderBottom: '1px solid #e8e8e8' }}>
                      <Checkbox onChange={this.handleSelectAll} checked={isAllSelected}>
                        {t("Select All")}
                      </Checkbox>
                    </div>

                    {/* แก้ไขชื่อ Style และการอ้างอิง State */}
                    <div className="scrollbar">
                      {treeData.length > 0 ? (
                        <Tree
                          checkable
                          showLine
                          switcherIcon={<CaretDownOutlined />}
                          onCheck={this.onCheckTree}
                          onExpand={this.onExpand}
                          expandedKeys={expandedKeys} // ใช้ค่าจาก destructuring
                          checkedKeys={selectedPermissions1}
                          treeData={treeData} // ใช้ตัวแปรที่คำนวณไว้แล้ว
                          selectable={false}
                          blockNode
                        />
                      ) : (
                        <Empty description={t("No permissions found")} />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          </Spin>
          <div
            style={{ textAlign: "center", marginTop: "20px", color: "#888" }}
          >
            <p>
              {t("version")} : {config?.version}
            </p>
          </div>
        </Modal>
      </>
    );
  }
}
// *********** End of AddRole ************

// ***********  Start of AddAdmin ************

export class AddAdmin extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      stateAlert: false,
      dataRole: [],
      selectedRole: [],
      expandedKeys: [],
      loadingCopy: false,
      adminResponse: {
        data: null,
        username: "",
        password: "",
      },
      IP: "",
      handleInput: {
        admin_type: "admin",
        roleID: "",
      },
    };
  }

  componentDidMount() {
    this.getIP();
  }

  // ใช้ตรวจสอบว่าถ้า Modal เปิด (props.show เปลี่ยน) ให้หยุด loading
  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show && this.props.show) {
      setTimeout(() => this.setState({ loading: false }), 500);
    }
  }

  // ฟังก์ชันค้นหาใน Select ที่ขาดไป
  filterRole = (input) => {
    return (input || "").toLowerCase();
  };

  // เพิ่มฟังก์ชันจัดการการ Expand
  onExpand = (expandedKeysValue) => {
    this.setState({ expandedKeys: expandedKeysValue });
  };


  handleOnSelectChange = (value) => {
    const { resDataRole, t } = this.props;
    this.setState({ loading: true });

    const filterRole = resDataRole.find((role) => role.name === value);

    if (!filterRole) {
      this.openNotificationWithIcon("error", t("Role not found."));
      this.setState({ loading: false });
      return;
    }

    // 1. ดึงข้อมูล Permission มาสร้าง Tree เพื่อหา Keys ที่จะสั่งให้กางออก (Expand)
    const tempTreeData = getViewTreeData(filterRole.permission || [], t);
    const allHeaderKeys = getAllHeaderKeys(tempTreeData);


    // 2. อัปเดต state พร้อมสั่งกางโหนด
    this.setState({
      selectedRole: filterRole,
      expandedKeys: allHeaderKeys, // สั่งให้กางออกทันทีที่เลือก
      stateAlert: false,
      adminResponse: { username: "", password: "", data: null },
      loading: false,
    });
  };
  getIP = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      this.setState({ IP: data?.ip });
    } catch (error) {
      console.error("Error fetching IP:", error);
    }
  };

  openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: "Notification",
      description: msg,
    });
  };

  funOnsubmitAddAdmin = async () => {
    const { fetchData } = this.props;
    const { selectedRole, IP } = this.state; //selectedMerchant
    const data = {
      roleID: selectedRole?.id || null,
      IP: IP,
    };

    if (!data.roleID) {
      this.openNotificationWithIcon(
        "error",
        this.props.t("Please Selected Role."),
      );
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    try {
      const res = await Apiauth.podtAddadmin(data);
      if (res.data.success === true) {
        this.openNotificationWithIcon("success", res.data.message);
        this.setState({ stateAlert: true });
        this.setState({
          adminResponse: {
            data: res.data,
            username: res.data.userAdmin.username,
            password: res.data.userAdmin.password,
          },
        });
        setTimeout(() => {
          this.setState({ selectedRole: undefined });
          this.setState(
            {
              loading: false,
            },
            () => {
              this.formRef.current?.resetFields();
            },
          );
          fetchData();
        }, 1000);
      } else {
        this.openNotificationWithIcon("error", res.data.message);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 1000);
      }
    } catch (err) {
      this.openNotificationWithIcon(
        "error",
        err.message || "An unexpected error occurred.",
      );
      this.setState({ loading: false });
      console.error("Error adding admin:", err);
    }
  };

  copyInfo = (item) => {
    if (!item) {
      return;
    }
    const { nameMerchang } = this.props;
    this.setState({ loadingCopy: true });

    const { username, password } = item;
    const { role } = item.data.data;

    // สร้าง Template String ตามรูปแบบที่ต้องการ
    const txt = `URL LOGIN: ${window.location.origin}/#/login
MERCHANT: ${nameMerchang}
ROLE: ${role}
PROVIDER: ${config?.web_name}
USERNAME: ${username}
PASSWORD: ${password}`;

    // ใช้ Clipboard API ในการคัดลอกข้อความ
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(txt)
        .then(() => {
          // แสดงการแจ้งเตือนเมื่อคัดลอกสำเร็จ
          setTimeout(() => {
            this.setState({ loadingCopy: false });
          }, 5000);
          this.openNotificationWithIcon(
            "success",
            this.props.t("Copied to clipboard!"),
          );
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          this.openNotificationWithIcon("error", "Failed to copy text.");
        });
    }
  };

  onClose = () => {
    const { handleClose } = this.props;
    if (this.formRef.current) {
      this.formRef.current?.resetFields();
    }
    this.setState(
      {
        selectedRole: [],
        expandedKeys: [], // ล้างค่าการกาง
        adminResponse: { username: "", password: "", data: null },
      },
      () => handleClose(),
    );
  };
  render() {
    const {
      loading,
      selectedRole,
      stateAlert,
      adminResponse,
      handleInput,
      loadingCopy,
      expandedKeys
    } = this.state;
    const { show, handleClose, t, resDataRole, resProfileAdmin } = this.props;
    if (!show) return;

    let arrData = Array.isArray(resDataRole) ? resDataRole : [];
    let recordDataRole = arrData.filter( (o) => o.merchantId === resProfileAdmin?.merchantId &&  o.name !== `Owner${o.merchantId}`,);
    // 1. เตรียมข้อมูล Tree (ส่งค่าว่างถ้ายังไม่ได้เลือก)
    const permissions = selectedRole?.permission || [];
    const treeData = getViewTreeData(permissions, t);

    // 2. คำนวณ Checked (เฉพาะ id ที่เป็น 1)
    const checkedKeys = permissions
      .filter(p => p.isPublic === 1)
      .map(p => p.id);

    return (
      <>
        <Modal
          title={t("add admin")}
          onCancel={this.onClose}
          maskClosable={false}
          open={show}
          confirmLoading={false}
          centered={false}
          footer={[
            <Button type="link" icon={<ExportOutlined />}>
              <Link to="/role">{t("add role")}</Link>
            </Button>,
            <Button onClick={this.onClose}>{t("close")}</Button>,
          ]}
          style={{ top: 20 }}
          width={800}
        >
          <Spin spinning={loading} tip={t("Loading...")}>
            {" "}
            <Form
              ref={this.formRef}
              layout="vertical"
              onFinish={this.funOnsubmitAddAdmin}
              initialValues={{
                username: handleInput.username,
                password: handleInput.password,
                uuid: handleInput.uuid,
              }}
            >
              <Row gutter={[21, 27]}>
                {" "}
                {/* Left Column: Admin Information */}
                <Col xs={24} md={9} className="flex flex-col">
                  <Divider orientation="left" plain>
                    <span
                      className="text-lg font-semibold"
                      style={{ fontWeight: "500" }}
                    >
                      {t("info system")}
                    </span>
                  </Divider>
                  <Form.Item label={t("Username")} name="username">
                    <Input
                      defaultValue="system will generate for you automatically"
                      readOnly
                      disabled
                      className="rounded-md"
                      value={handleInput.username}
                    />
                    <p className="m-0  text-sm">
                      <b>
                        <em>
                          <small className="text-danger">
                            *{" "}
                            {t(
                              "Username the system will generate for you automatically.",
                            )}
                          </small>
                        </em>
                      </b>
                    </p>
                  </Form.Item>
                  {/* <Form.Item
                    label={t("role")}
                    name="roleID"
                    rules={[
                      {
                        required: true,
                        message: t("Please Selected the Role!"),
                      },
                    ]}
                  >
                    <Select
                      style={{
                        width: "100%",
                        boxShadow: "none",
                        border: "none",
                      }}
                      placeholder="Select Role"
                      onChange={(value) =>
                        this.handleOnSelectChange(value, "roleID")
                      }
                      value={handleInput.roleID}
                      options={recordDataRole
                        ?.map((role) => {
                          if (CheckAdminType("add_admin_view_role")) {
                            return {
                              label: `${role.name}`,
                              value: role.name,
                            };
                          } else if (
                            role.name !== "Subowner" &&
                            role.name !== "SuperOwner"
                          ) {
                            return {
                              label: `${role.name}`,
                              value: role.name,
                            };
                          }
                          return null;
                        })
                        .filter((option) => option !== null)}
                      filterOption={(input, option) => {
                        const labelMatch = option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase());
                        const customFilterMatch = this.filterRole(input);
                        return labelMatch || customFilterMatch;
                      }}
                    />
                  </Form.Item> */}
                  <Form.Item
                    label={t("role")}
                    name="roleID"
                    rules={[{ required: true, message: t("Please Selected the Role!") }]}
                  >
                    <Select
                      style={{ width: "100%", boxShadow: "none", border: "none" }}
                      placeholder="Select Role"
                      onChange={(value) => this.handleOnSelectChange(value, "roleID")}
                      value={handleInput.roleID}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                      options={recordDataRole?.flatMap((role) => {
                        const isAllowed = CheckAdminType("add_admin_view_role") || !["Subowner", "SuperOwner"].includes(role.name);
                        return isAllowed ? [{ label: role.name, value: role.name }] : [];
                      })}
                    />
                  </Form.Item>

                  <Flex wrap gap="small" className="mt-4">
                    <Button
                      onClick={handleClose}
                      htmlType="reset"
                      danger
                      className="rounded-md"
                    >
                      {t("cancel")}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="rounded-md"
                    >
                      {t("confirm")}
                    </Button>
                  </Flex>
                </Col>
                {/* Right Column: Accessible Permissions */}
                <Col xs={24} md={15}>
                  <Flex gap="middle" vertical>
                    <Divider orientation="left" plain>
                      <span
                        className="text-lg font-semibold"
                        style={{ fontWeight: "500" }}
                      >
                        {stateAlert ? t("user info") : t("accessible")}
                      </span>
                    </Divider>
                    <div className="permissions-container overflow-y-auto max-h-64 p-2  rounded-md bg-gray-50">
                      {stateAlert ? (
                        <Result
                          status="success"
                          title="Successfully!"
                          className={!stateAlert ? `d-none` : `out`}
                          children={
                            <>
                              <Flex wrap gap="small" justify="center">
                                <Input
                                  readOnly
                                  style={{
                                    color: "#5A5A5A",
                                  }}
                                  width={100}
                                  addonBefore={<UserOutlined />}
                                  suffix={
                                    <Tooltip title="Copy username">
                                      <CopyOutlined
                                        onClick={() =>
                                          CopyTextToClipboard(
                                            adminResponse?.username,
                                          )
                                        }
                                        style={{
                                          cursor: "copy",
                                          color: "#2196f3",
                                        }}
                                      />
                                    </Tooltip>
                                  }
                                  value={adminResponse?.username}
                                />
                                <Input
                                  readOnly
                                  width={100}
                                  style={{
                                    color: "#5A5A5A",
                                  }}
                                  addonBefore={<KeyOutlined />}
                                  suffix={
                                    <Tooltip title="Copy password">
                                      <CopyOutlined
                                        onClick={() =>
                                          CopyTextToClipboard(
                                            adminResponse?.password,
                                          )
                                        }
                                        style={{
                                          cursor: "copy",
                                          color: "#2196f3",
                                        }}
                                      />
                                    </Tooltip>
                                  }
                                  value={adminResponse?.password}
                                />
                                <Input
                                  width={100}
                                  style={{
                                    color: "#5A5A5A",
                                  }}
                                  autoFocus
                                  readOnly
                                  addonBefore={<LinkOutlined />}
                                  suffix={
                                    <Tooltip title="Copy link">
                                      <CopyOutlined
                                        onClick={() =>
                                          CopyTextToClipboard(
                                            window.location.origin + "/#login",
                                          )
                                        }
                                        style={{
                                          cursor: "copy",
                                          color: "#2196f3",
                                        }}
                                      />
                                    </Tooltip>
                                  }
                                  value={window.location.origin + "/#login"}
                                />
                              </Flex>
                              <br />

                              <Flex wrap gap="small" justify="center">
                                <Tooltip
                                  title={
                                    !loadingCopy
                                      ? "* คัดลอกรายละเอียด User ทั้งหมด Copy all user details."
                                      : ""
                                  }
                                >
                                  <Button
                                    disabled={loadingCopy}
                                    variant={
                                      !loadingCopy ? "solid" : "outlined"
                                    }
                                    color="primary"
                                    icon={
                                      !loadingCopy ? (
                                        <CopyOutlined />
                                      ) : (
                                        <CheckOutlined />
                                      )
                                    }
                                    onClick={() => this.copyInfo(adminResponse)}
                                  >
                                    {!loadingCopy ? "Copy details" : "Copied"}
                                  </Button>
                                </Tooltip>
                              </Flex>
                            </>
                          }
                        />
                      ) : null}
                      {!stateAlert && (
                        <div className="p-2 rounded-md bg-gray-50 ">
                          {/* เช็คว่ามีการเลือก Role หรือยัง และมี Permission ไหม */}
                          {!selectedRole || !selectedRole.permission || selectedRole.permission.length === 0 ? (
                            <Empty
                              image={Empty.PRESENTED_IMAGE_SIMPLE}
                              description={t("Please select a role to see permissions.")}
                            />
                          ) : (
                            <div className="scrollbar">
                              <Tree
                                checkable
                                selectable={false}
                                treeData={treeData}
                                checkedKeys={checkedKeys}
                                expandedKeys={expandedKeys}
                                onExpand={this.onExpand}
                                showLine={{ showLeafIcon: false }}
                                showIcon
                                blockNode
                                switcherIcon={<CaretDownOutlined />}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>
            </Form>
          </Spin>
          <div
            style={{ textAlign: "center", marginTop: "20px", color: "#888" }}
          >
            <p>
              {t("version")} : {config?.version}
            </p>{" "}
          </div>
        </Modal>
      </>
    );
  }
}
// *********** End of AddAdmin ************

// ************ Start of DetailAdminModel ************
export class DetailAdminModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      dataRole: [],
      loading: true,
      permissionsData: [],
    };
  }


  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1500);
  }

  handleOnSelectChange = (isRole) => {
    const { resDataRole } = this.props;

    let roleData = resDataRole;
    let filterRole = undefined;

    this.setState({ loading: true });
    filterRole = roleData.find((role) => role.id === isRole?.roleID);
    this.setState({ permissionsData: filterRole?.permission || [] });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1500);
  };
  onTab1Change = (key) => {
    const { isData } = this.props;
    this.setState({ activeTabKey1: key }, () =>
      this.handleOnSelectChange(isData),
    );
  };

  onClose = () => {
    const { handleClose } = this.props;
    if (handleClose) {
      this.setState({ activeTabKey1: "tab1", permissionsData: [] }, () =>
        handleClose(),
      );
    }
  };

  render() {
    const { show, isData, nameMerchang } = this.props;
    const { activeTabKey1, permissionsData } = this.state;
    if (!show) {
      return null;
    }
    const tabList = [
      {
        key: "tab1",
        tab: t("Personnel Info"),
      },
      {
        key: "tab2",
        tab: t("Permission Info"),
      },
    ];

    // แปลงข้อมูลเป็น Tree Format
    const treeData = getViewTreeData(permissionsData, t);

    // สร้างอาเรย์ของ key ที่ต้อง "checked" ใน Tree
    const checkedKeys = permissionsData
      .filter(item => item.isPublic === 1)
      .map(item => item.id);

    const contentList = {
      tab1: (
        <div className="row clearfix">
          <div className="col-lg-12">
            <div className="">
              <div className="body">
                <div className="tab-content p-0">
                  <div className={`tab-pane active`}>
                    <div className="row clearfix p-3">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("Username")}
                                  </strong>
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    border: "none",
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                  }}
                                >
                                  {isData?.username || "-"}
                                  <CopyOutlined
                                    onClick={() =>
                                      CopyTextToClipboard(isData?.username)
                                    }
                                    style={{
                                      cursor: "copy",
                                      marginLeft: "5px",
                                    }}
                                    title={t("คัดลอก username")}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("Roles")}
                                  </strong>
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    border: "none",
                                  }}
                                >
                                  <Tag
                                    color={tagsBage(
                                      isData?.role && isData.role.length > 14
                                        ? isData.role.substring(0, 14)
                                        : isData.role,
                                    )}
                                  >
                                    {isData?.role && isData.role.length > 14
                                      ? `${isData.role.substring(0, 14)}`
                                      : isData?.role || "-"}
                                  </Tag>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("Type admin")}
                                  </strong>
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    border: "none",
                                  }}
                                >
                                  {isData?.admin_type}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("status")}
                                  </strong>
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    border: "none",
                                  }}
                                >
                                  <Tag
                                    color={tagsBageStatus(isData?.admin_status)}
                                  >
                                    {isData?.admin_status === 1
                                      ? t("Active")
                                      : t("Inactive")}
                                  </Tag>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("merchant")}
                                  </strong>{" "}
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    border: "none",
                                  }}
                                >
                                  {nameMerchang + ` (${isData?.merchantId})` ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    border: "none",
                                  }}
                                >
                                  <strong style={{ fontWeight: "700" }}>
                                    {t("createdAt")}
                                  </strong>{" "}
                                </td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td style={{ border: "none" }}></td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    border: "none",
                                  }}
                                >
                                  <Tooltip
                                    placement="topLeft"
                                    title={moment(isData?.created_at).format(
                                      "YYYY-MM-DD HH:mm:ss",
                                    )}
                                  >
                                    <span
                                      className="text-truncate"
                                      style={{
                                        textWrap: "nowrap",
                                        maxWidth: "150px",
                                        display: "inline-block",
                                      }}
                                    >
                                      {FormatTimeAgo(isData?.created_at) || "-"}
                                    </span>
                                  </Tooltip>{" "}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      tab2: (
        <div className="row clearfix">
          <div className="col-lg-12">
            <div className="">
              <div className="body">
                <div className="tab-content p-0">
                  <div className={`tab-pane active`}>
                    <div className="p-3">
                      <div className="">
                        <h5>
                          {t("Permissions list for")}{" "}
                          <Tag color={tagsBage(isData?.role)}>
                            {isData?.name || "-"}
                          </Tag>
                        </h5>
                        <br />
                        <div className="scrollbar" >
                          {treeData.length > 0 ? (
                            <Tree
                              checkable
                              defaultExpandAll
                              selectable={false}
                              checkedKeys={checkedKeys}
                              treeData={treeData}
                              showIcon
                              switcherIcon={<CaretDownOutlined />}
                              showLine={{ showLeafIcon: false }}
                              blockNode
                            // ทำให้เป็น Read-only ทั้งหมด
                            />
                          ) : (
                            <p>{t("No permissions data available.")}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    };
    return (
      <>
        <Modal
          title={t("Details")}
          onCancel={this.onClose}
          open={show}
          confirmLoading={false}
          maskClosable={false}
          centered={false}
          style={{ top: 20 }}
          width={800}
          footer={[<Button onClick={this.onClose}>{t("close")}</Button>]}
        >
          <Card
            style={{ width: "100%", boxShadow: "none", border: "none" }}
            title={<></>}
            tabList={tabList}
            activeTabKey={activeTabKey1}
            onTabChange={this.onTab1Change}
          >
            {isData ? (
              contentList[activeTabKey1]
            ) : (
              <p>{t("Loading role data...")}</p>
            )}
            <Divider orientation="center">
              <small style={{ fontSize: "11px", color: "#888" }}>
                Version: {config.version}
              </small>
            </Divider>
          </Card>
        </Modal>
      </>
    );
  }
}
// ************ End of DetailAdminModel ************

// ************ Start of PaymentModel ************
export class PaymentModel extends React.Component {
  formRef = React.createRef();

  state = {
    customerUuid: undefined,
    amount: undefined,
    customerData: [],
    remark: "",
    paymentType: "QR",
    loading: false,
    resultShow: false,
    ReferenceId: null,
    customerName: null,
    customerAccountNo: null,
  };

  componentDidMount() {
    this.setState({ formShow: true });
  }

  // แก้ไข: ใช้ componentDidUpdate เพื่อเช็ค props.customerData ที่เข้ามาใหม่
  componentDidUpdate(prevProps) {
    if (this.props.customerData !== prevProps.customerData) {
      this.setState({ customerData: this.props.customerData });
    }
  }

  componentWillUnmount() { }

  handleFormSubmit = async (values) => {
    const { handleShowQrcode } = this.props;

    let postData = {
      customerUuid: values?.customerUuid,
      amount: values?.amount,
      referenceId: generateReferenceIdCustomFormat(),
      paymentType: values?.paymentType,
      remark: values?.remark,
      note: "",
    };
    this.setState({ loading: true, resultShow: false, qrStatus: "loading" });

    try {
      const res = await Apibank.getPayment(postData);

      if (res.data.success) {
        this.props.showToast(
          "success",
          "กรุณาสแกน QRcode เพื่อทำรายการให้สำเร็จ",
        );
        this.setState(
          {
            loading: false,
          },
          () => {
            handleShowQrcode(res.data.data);
          },
        );
      } else {
        this.props.showToast("error", res.data.message);
        this.setState({ loading: false });
      }
    } catch (err) {
      this.props.showToast(
        "error",
        err.message || "เกิดข้อผิดพลาดในการชำระเงิน!",
      );
      console.error("Payment error:", err);
      this.setState({ loading: false });
    }
  };
  handleCancel = () => {
    if (this.formRef.current) {
      this?.formRef?.current?.resetFields();
    }
    this.setState(
      {
        customerUuid: undefined,
        amount: undefined,
        loading: false,
      },
      () => this.props.handleClose(),
    );
  };

  handleClearInput = (e) => {
    this.formRef.current.resetFields([e]);
  };

  handleSearchCustomer = async (searchText) => {
    if (!searchText) {
      this.setState({ customerData: [] });
      return;
    }
    this.setState({ loading: true });
    try {
      const res = await Apiauth.chack_uuid({ name: searchText });
      if (res.data.success) {
        let isArray = Array.isArray(res.data.data) ? res.data.data : [];
        this.setState({ customerData: isArray });
      } else {
        this.setState({ customerData: [] });
      }
    } catch (error) {
      console.error("Error searching customer:", error);
      this.setState({ customerData: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { show, t } = this.props;
    const { loading, customerData } = this.state;
    const selectOptions = Array.isArray(customerData)
      ? customerData?.map((customer, index) => ({
        value: customer?.customer_uuid,
        key: index,
        label: (
          <>
            <Text style={{ marginRight: "5px" }}>{customer?.name}</Text>
            {" - "}
            <Text type="secondary" style={{ fontWeight: "500" }}>
              {customer?.account_no}
            </Text>
          </>
        ),
        searchName: customer?.name.toLowerCase(),
        searchAccountNo: customer?.account_no.toLowerCase(),
      }))
      : [];
    return (
      <Modal
        title={t("Payment")}
        open={show}
        onCancel={() => this.handleCancel()}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <>
            <Button danger key="back" onClick={() => this.handleCancel()}>
              {t("ปิด")}
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={() => this.formRef.current.submit()}
              loading={loading}
            >
              {t("สร้างรายการฝาก")}
            </Button>
          </>,
        ]}
      >
        <br />
        <Spin spinning={loading} tip="กำลังสร้าง QR Code...">
          <Form
            ref={this.formRef}
            layout="vertical"
            onFinish={this.handleFormSubmit}
            initialValues={{
              customerUuid: this.state.customerUuid,
              amount: this.state.amount,
              paymentType: this.state.paymentType,
              remark: this.state.remark,
            }}
          >
            <Form.Item
              name="customerUuid"
              label={t("Customer")}
              rules={[{ required: true, message: t("กรุณาเลือก Customer!") }]}
            >
              <Select
                className=""
                showSearch
                placeholder={t("เลือก Customer หรือค้นหาด้วยชื่อ")}
                allowClear
                optionFilterProp="children"
                onSearch={this.handleSearchCustomer}
                options={selectOptions}
                filterOption={(input, option) => {
                  const lowerCaseInput = input.toLowerCase();
                  return (
                    option.searchName?.includes(lowerCaseInput) ||
                    option.searchAccountNo?.includes(lowerCaseInput)
                  );
                }}
              />
            </Form.Item>
            {/* ส่วนอื่นๆ ของ Form */}
            <Form.Item
              name="amount"
              label={t("จำนวน")}
              rules={[
                {
                  required: true,
                  message: t("จำนวนเงินต้องเป็นตัวเลขและมากกว่า 0!"),
                },
              ]}
            >
              <InputNumber
                min={1}
                id="amount"
                style={{ width: "100%", boxShadow: "none" }}
                placeholder={t("กรอกจำนวนเงิน")}
                type="number"
                prefix={<DollarOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              />
            </Form.Item>
            <Form.Item
              name="paymentType"
              label={t("ประเภท")}
              rules={[
                {
                  required: true,
                  message: t("กรุณาเลือกประเภทการชำระเงิน!"),
                },
              ]}
            >
              <Radio.Group
                onChange={(e) => this.setState({ paymentType: e.target.value })}
              >
                <Radio value="QR">QR</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="remark" label={t("หมายเหตุ")}>
              <TextArea
                rows={4}
                placeholder={t("เพิ่มหมายเหตุ (ไม่บังคับ)")}
                onChange={(e) => this.setState({ remark: e.target.value })}
              />
            </Form.Item>
          </Form>
        </Spin>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************ End of PaymentModel ************

// ************ PayinDetailsModel ************

export class PayinDetailsModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 576,
    };
  }

  componentDidMount() {
    window.removeEventListener("resize", this.handleResize); // ล้างของเก่าถ้ามี
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 576 });
  };

  filterBankAccount = (id) => {
    const { allBankAccountData } = this.props;
    if (!id || !Array.isArray(allBankAccountData)) return null;
    return allBankAccountData.find((account) => account.id === id) || null;
  };

  render() {
    const { show, handleClose, isData, t, nameMerchang, isMobile } = this.props;
    if (!isData) return null;

    const bankInfo = this.filterBankAccount(
      isData?.bankAccount_id || isData?.Create_deposits_uuid?.bankAccount_id,
    );

    let created_at =
      isData?.eventCreatedAt === 0
        ? isData?.created_at
        : isData?.eventCreatedAt;
    let updated_at =
      isData?.eventUpdatedAt === 0
        ? isData?.updated_at
        : isData?.eventUpdatedAt;
    let successed = isData?.status === "SUCCESS";

    // ฟังก์ชันช่วยแสดงผล Copy คู่กับข้อมูล
    const renderValue = (value, isCopyable = false) => {
      return (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              wordBreak: "break-all",
            }}
          >
            {value || <em style={{ color: "#bfbfbf" }}>{t("No data")}</em>}
            {isCopyable && value && (
              <CopyOutlined
                style={{ marginLeft: 8, color: "#1890ff", cursor: "pointer" }}
                onClick={() => CopyTextToClipboard(value)}
              />
            )}
          </div>
        </>
      );
    };

    return (
      <Modal
        width={750}
        closable={true}
        open={show}
        onCancel={handleClose}
        title={t("Payin Details")}
        maskClosable={false}
        style={{ top: 20 }}
        footer={[
          <Button onClick={handleClose} key="close-btn" block={isMobile}>
            {t("close")}
          </Button>,
        ]}
      >
        {/* Success Header Area */}
        <div
          className="fs-sm-10 fs-14"
          style={{
            backgroundColor: "#f6ffed",
            borderBottom: "1px solid #b7eb8f",
            padding: "12px 24px",
            color: tagsColorAlert(isData?.status),
            fontWeight: "bold",
            marginBottom: 10,
          }}
        >
          {getAlerIcon(isData?.status)} {isData?.status} : {isData?.note || ""}
        </div>

        <div style={{ padding: "0px" }}>
          <Descriptions
            bordered
            column={1} // บังคับเป็น 1 คอลัมน์เพื่อให้เหมือนตารางในรูป
            size="middle"
            labelStyle={{
              width: isMobile ? "120px" : "250px",
              backgroundColor: "#ffffff",
              color: "#8c8c8c",
            }}
            contentStyle={{ backgroundColor: "#ffffff" }}
          >
            <Descriptions.Item label={t("ID")}>
              {renderValue(isData?.id, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("Ref")}>
              {renderValue(isData?.logUuid, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("payEasyRef")}>
              {renderValue(isData?.payEasyRef, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("merchantOrderId")}>
              {renderValue(isData?.merchantOrderId, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("PlatformOrderID")}>
              {renderValue(isData?.platformOrderId, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("Merchant")}>
              {nameMerchang}
            </Descriptions.Item>
            <Descriptions.Item label="Merchant ID">
              {isData?.merchantId}
            </Descriptions.Item>

            <Descriptions.Item label={t("Type")}>
              <Tag color={tagsTypeBageColor(isData?.type)}>{isData?.type}</Tag>
            </Descriptions.Item>

            <Descriptions.Item label={t("amount")}>
              <strong>{Intl.NumberFormat().format(isData?.amount)}.-</strong>
            </Descriptions.Item>
            <Descriptions.Item label={t("tarnsfer amt")}>
              {Intl.NumberFormat().format(isData?.transferAmount)}.-
            </Descriptions.Item>
            <Descriptions.Item label={t("deduction credit")}>
              {Intl.NumberFormat().format(isData?.settleAmount)}.-
            </Descriptions.Item>
            <Descriptions.Item label={t("fee")}>
              {Intl.NumberFormat().format(isData?.fee)}.-
            </Descriptions.Item>
            <Descriptions.Item label={t("Currency")}>
              {isData?.currency}
            </Descriptions.Item>

            <Descriptions.Item label={t("CREATED DATE")}>
              {moment(created_at).format("YYYY-MM-DD HH:mm:ss")}
            </Descriptions.Item>
            <Descriptions.Item label={t("SUCCESS TIME")}>
              {updated_at
                ? moment(updated_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label={t("COMPLETION TIME")}>
              {successed
                ? calculateTimeDifference(created_at, updated_at)
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label={t("status")}>
              <Tag
                color={tagsBageStatus(isData?.status)}
                icon={getIcon(isData?.status)}
              >
                {t(isData?.status)}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label={t("note")}>
              {isData?.note || t("-")}
            </Descriptions.Item>
          </Descriptions>

          {/* Customer Account Section */}
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "10px 16px",
              fontWeight: "bold",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <UserOutlined />{" "}
            <span style={{ marginLeft: 8 }}>{t("Customer Account")}</span>
          </div>
          <Descriptions
            bordered
            column={1}
            size="middle"
            labelStyle={{ width: isMobile ? "120px" : "250px" }}
          >
            <Descriptions.Item label={t("UUID")}>
              {renderValue(isData?.customer, true)}
            </Descriptions.Item>
            <Descriptions.Item label={t("customer name")}>
              {FormatDataSettleSlipJson(isData?.bank)?.accountName}
            </Descriptions.Item>
            <Descriptions.Item label={t("Bank")}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  size="small"
                  src={iconBank(
                    FormatDataSettleSlipJson(isData?.bank)?.bankCode,
                  )}
                  style={{ marginRight: 8 }}
                />
                {t(FormatDataSettleSlipJson(isData?.bank)?.bankCode)}
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t("Account Number")}>
              {renderValue(
                FormatDataSettleSlipJson(isData?.bank)?.accountNo,
                true,
              )}
            </Descriptions.Item>
          </Descriptions>

          {/* Merchant account Section */}
          {bankInfo && (
            <>
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "10px 16px",
                  fontWeight: "bold",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <UserOutlined />{" "}
                <span style={{ marginLeft: 8 }}>{t("To bank account")}</span>
              </div>
              <Descriptions
                bordered
                column={1}
                size="middle"
                labelStyle={{ width: isMobile ? "120px" : "250px" }}
              >
                <Descriptions.Item label={t("Account Name")}>
                  {bankInfo?.accountName}
                </Descriptions.Item>
                <Descriptions.Item label={t("Account Number")}>
                  {renderValue(bankInfo?.accountNumber, true)}
                </Descriptions.Item>
                <Descriptions.Item label={t("Bank")}>
                  {bankInfo?.bank?.bankNameTh}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
        </div>

        <div style={{ textAlign: "center", padding: "15px", color: "#bfbfbf" }}>
          <small>Version: {config?.version}</small>
        </div>
      </Modal>
    );
  }
}
// ************ End of PayinDetailsModel ************

// ************ Start  DetailsMerchantModal ************
export class DetailsMerchantModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyTab: "1",
      titleDetails: t("Details"),
      isId: "descriptions",
      loadingPdf: false,
    };
  }

  // แก้ไขชื่อสะกดคำ และปรับปรุง Logic การเลือก ID
  onChangeTab = (key) => {
    const tabMap = {
      1: { titleDetails: t("Details"), isId: "descriptions" },
      2: { titleDetails: t("Details"), isId: "userMerchant" },
    };
    this.setState({
      keyTab: key,
      ...tabMap[key],
    });
  };

  handleDownloadPdf = async () => {
    const { isData } = this.props;
    const { isId } = this.state;
    if (!isData) return;

    this.setState({ loadingPdf: true });

    const element = document.getElementById(isId);
    if (!element) {
      console.error("Target element not found:", isId);
      this.setState({ loadingPdf: false });
      return;
    }

    try {
      // ปรับปรุง html2canvas ให้รองรับสีกระดาษขาวและคุณภาพที่ชัดขึ้น
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const padding = 10;
      const safeWidth = pdfWidth - padding * 2;
      const safeHeight = pdfHeight - padding * 2;

      const ratio = Math.min(
        safeWidth / canvas.width,
        safeHeight / canvas.height,
      );
      const newImgWidth = canvas.width * ratio;
      const newImgHeight = canvas.height * ratio;

      pdf.addImage(imgData, "PNG", padding, padding, newImgWidth, newImgHeight);
      pdf.save(
        `Detail_${isData?.name || "Merchant"}_${moment().format("YYYYMMDD")}.pdf`,
      );
    } catch (error) {
      console.error("Error generating PDF:", error);
      // แนะนำ: เพิ่ม showToast("error", "ไม่สามารถสร้าง PDF ได้")
    } finally {
      this.setState({ loadingPdf: false });
    }
  };

  onClose = () => {
    const { handleClose } = this.props;
    this.setState({ keyTab: "1", isId: "descriptions" }, () => {
      handleClose();
    });
  };

  render() {
    const { show, isData, t } = this.props;
    const { keyTab, loadingPdf } = this.state; // titleDetails,

    if (!isData) return null;

    // ปรับปรุงการหา User Info ให้ปลอดภัยขึ้น
    const adminList = Array.isArray(isData?.Admins)
      ? isData.Admins
      : isData?.Admins
        ? [isData.Admins]
        : [];
    const userInfo = adminList.find(
      (admin) => admin !== null && admin !== undefined,
    );

    // Helper สำหรับจัดฟอร์แมตตัวเลข (Clean Code)
    const formatCurrency = (val) =>
      Intl.NumberFormat().format(parseFloat(val || 0).toFixed(2));

    let noteTxt = t(`*กรุณาตั้งค่า ⚙️ CALLBACK_URL ให้ครบตามที่ระบบกำหนด`);

    let cb_payout_url = isData?.withdrawalCallbackUrl;
    let cb_payin_url = isData?.depositCallbackUrl;
    let cb_onHold_url = isData?.depositOnHoldCallbackUrl;

    let cb_in = ["https://YOUR_PAYOUT_CALLBACK_URL.com"];
    let cb_out = ["https://YOUR_PAYIN_CALLBACK_URL.com"];
    let cb_on = [
      "https://YOUR_OnHold_CALLBACK_URL.com",
      "https://YOUR_OnHold_URL.com",
    ];

    let payoutCB = cb_in.includes(cb_payout_url) || isEmpty(cb_payout_url);
    let payinCB = cb_out.includes(cb_payin_url) || isEmpty(cb_payin_url);
    let onHoldCB = cb_on.includes(cb_onHold_url) || isEmpty(cb_onHold_url);

    let tokenExpired = isTokenExpired(isData?.token_auth);

    const itemsDetail = [
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("merchant ID")}</span>
        ),
        children: isData?.id || "-",
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("agentID")}</span>
        ),
        children: isData?.agentID || "-",
        span: 24,
        style: { display: isData?.agentID ? "" : "none" },
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Merchant")}</span>
        ),
        children: isData?.name || "-",
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Status")}</span>
        ),
        children: (
          <Tag color={tagsBageStatus(isData?.isActive ? "Active" : "Inactive")}>
            {isData?.isActive ? "Active" : "Inactive"}
          </Tag>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("credit Merchant")}
          </span>
        ),
        children: formatCurrency(isData?.balance),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase", fontWeight: "600" }}>
            {t("WTH. Callback Url")}
          </span>
        ),
        children: (
          <>
            <div className="text-wrap">
              <code style={{ color: "rgba(0,0,0,0.88)" }}>
                {payoutCB ? (
                  <small style={{ color: "red" }}>
                    <u>{noteTxt}</u>
                  </small>
                ) : (
                  cb_payout_url
                )}{" "}
                <CopyTwoTone
                  style={{
                    display: payoutCB ? "none" : "",
                  }}
                  onClick={() => CopyTextToClipboard(cb_payout_url)}
                />
              </code>{" "}
            </div>{" "}
          </>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("WTH. Limit")}
          </span>
        ),
        children: formatCurrency(isData?.withdrawalLimit),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Min WTH.")}</span>
        ),
        children: formatCurrency(isData?.witdrow_minlimit),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("WTH. Fee")}</span>
        ),
        children: formatCurrency(isData?.FeeSetting?.withdrawalFeePercentage),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("maximum WTH. TxsPer BankAccount")}
          </span>
        ),
        children: formatCurrency(isData?.maximumWithdrawTxsPerBankAccount),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("maximum WTH. VolumePer BankAccount")}
          </span>
        ),
        children: formatCurrency(isData?.maximumWithdrawVolumePerBankAccount),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase", fontWeight: "600" }}>
            {t("Dep. Callback Url")}
          </span>
        ),
        children: (
          <>
            <div className="text-wrap">
              <code style={{ color: "rgba(0,0,0,0.88)" }}>
                {payinCB ? (
                  <small style={{ color: "red" }}>
                    <u>{noteTxt}</u>
                  </small>
                ) : (
                  cb_payin_url
                )}{" "}
                <CopyTwoTone
                  style={{ display: payinCB ? "none" : "" }}
                  onClick={() => CopyTextToClipboard(cb_payin_url)}
                />
              </code>{" "}
            </div>{" "}
          </>
        ),

        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Min Dep.")}</span>
        ),
        children: formatCurrency(isData?.deposit_minlimit),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Dep. Fee")}</span>
        ),
        children: formatCurrency(isData?.FeeSetting?.depositFeePercentage),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase", fontWeight: "600" }}>
            {t("OnHold Callback Url")}
          </span>
        ),
        children: (
          <>
            <div className="text-wrap">
              <code style={{ color: "rgba(0,0,0,0.88)" }}>
                {onHoldCB ? (
                  <small style={{ color: "red" }}>
                    <u>{noteTxt}</u>
                  </small>
                ) : (
                  cb_onHold_url
                )}{" "}
                <CopyTwoTone
                  style={{
                    display: onHoldCB ? "none" : "",
                  }}
                  onClick={() => CopyTextToClipboard(cb_onHold_url)}
                />
              </code>{" "}
            </div>{" "}
          </>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("Verify Slip Fee")}
          </span>
        ),
        children: formatCurrency(isData?.FeeSetting?.deposit_fee_slep),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>
            {t("Verify Account Fee")}
          </span>
        ),
        children: formatCurrency(isData?.FeeSetting?.verifyAccountFee),
        span: 24,
      },

      // token auth
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("token auth")}</span>
        ),
        children: (
          <>
            <div className="text-wrap">
              <code
                style={{
                  fontSize: 12,
                }}
              >
                {tokenExpired ? (
                  <code style={{ color: "red" }}>*{t("Token expired.")}</code>
                ) : (
                  <span
                    style={{
                      color: "rgba(0, 0, 0, 0.88)",
                      fontSize: 12,
                      cursor: "copy",
                    }}
                    className="hover"
                    onClick={() => CopyTextToClipboard(isData?.token_auth)}
                  >
                    {isData?.token_auth}
                  </span>
                )}{" "}
              </code>{" "}
            </div>{" "}
          </>
        ),
        span: 24,
        style: { display: isData?.token_auth ? "" : "none" },
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("createdAt")}</span>
        ),
        children: (
          <span
            title={moment(isData?.created_at).format("YYYY-MM-DD HH:mm:ss")}
          >
            {moment(isData?.created_at).format("YYYY-MM-DD HH:mm:ss")}
          </span>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("days used")}</span>
        ),
        children: (
          <span>
            {calculateDaysUsed(isData?.created_at)}
          </span>
        ),
        span: 24,
      },
    ];

    const itemsUserInfo = [
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("username")}</span>
        ),
        children: (
          <>
            {userInfo?.username || "-"}{" "}
            <CopyTwoTone
              onClick={() => CopyTextToClipboard(userInfo?.username)}
            />
          </>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Password")}</span>
        ),
        children: (
          <>
            {userInfo?.genPass || (
              <span style={{ color: "red" }}>
                {"* ร้านค้าที่สร้างก่อนวันที่ 12/8/2025 จะไม่มีข้อมูลนี้"}
              </span>
            )}{" "}
            {userInfo?.genPass && (
              <CopyTwoTone
                onClick={() => CopyTextToClipboard(userInfo?.genPass)}
              />
            )}
          </>
        ),
        span: 24,
      },
      {
        label: <span style={{ textTransform: "uppercase" }}>{t("Type")}</span>,
        children: <>{userInfo?.admin_type || "-"} </>,
        span: 24,
      },
      {
        label: <span style={{ textTransform: "uppercase" }}>{t("Roles")}</span>,
        children: (
          <>
            {userInfo?.role === "Subowner"
              ? "SuperOwner"
              : userInfo?.role || "-"}{" "}
          </>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("Status")}</span>
        ),
        children: (
          <Tag
            color={tagsBageStatus(
              userInfo?.admin_status === 1 ? "Active" : "Inactive",
            )}
          >
            {userInfo?.admin_status === 1 ? "Active" : "Inactive"}
          </Tag>
        ),
        span: 24,
      },
      {
        label: (
          <span style={{ textTransform: "uppercase" }}>{t("IP address")}</span>
        ),
        children: (
          <>
            {userInfo?.IP || "-"}{" "}
            {userInfo?.IP && (
              <CopyTwoTone
                onClick={() => CopyTextToClipboard(userInfo?.IP || "-")}
              />
            )}
          </>
        ),
        span: 24,
      },
    ];

    const itemsTabs = [
      {
        key: "1",
        label: t("Merchant Info"),
        children: (
          <Spin spinning={loadingPdf}>
            <Descriptions
              id="descriptions"
              size="middle"
              bordered
              // title={titleDetails}
              items={itemsDetail}
            />
          </Spin>
        ),
      },
      ...(userInfo
        ? [
          {
            key: "2",
            label: t("User info"),
            children: (
              <Spin spinning={loadingPdf}>
                <Descriptions
                  id="userMerchant"
                  size="middle"
                  bordered
                  // title={titleDetails}
                  items={itemsUserInfo}
                />
              </Spin>
            ),
          },
        ]
        : []),
    ];

    return (
      <Modal
        width={850}
        open={show}
        closable={false}
        maskClosable={false}
        title={t("Details")}
        style={{ top: 10 }}
        footer={[
          <Button key="close" onClick={this.onClose}>
            {t("close")}
          </Button>,
          <Button
            key="download-pdf"
            type="primary"
            onClick={this.handleDownloadPdf}
            loading={loadingPdf}
          >
            {t("Download PDF")}
          </Button>,
        ]}
      >
        <Tabs
          activeKey={keyTab}
          animated
          onChange={this.onChangeTab}
          items={itemsTabs}
        />
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************ End of DetailsMerchantModal ************

//UpslipModel
export class UpslipModel extends React.Component {
  state = {
    loading: false,
  };
  handleChangeLoading = (_isLoad) => {
    this.setState({ loading: _isLoad });
  };
  render() {
    const { show, handleClose, isData, t, fetchData } = this.props;
    const { loading } = this.state;

    return (
      <>
        <Modal
          width={450}
          maskClosable={false}
          closable={false}
          open={show}
          title={<>{t("แจ้งฝากเงิน (Up Slip)")}</>}
          style={{ top: 20 }}
          footer={[<Button onClick={handleClose}>{t("close")}</Button>]}
        >
          {!isData ? (
            <>
              <Empty />
            </>
          ) : (
            <>
              <Form variant={"filled"}>
                <Form.Item label="" name="uuid">
                  UUID
                  <Input
                    disabled={loading}
                    className="mt-2"
                    readOnly
                    value={isData?.uuid}
                    onClick={() => CopyTextToClipboard(isData?.uuid)}
                  />
                </Form.Item>

                <Form.Item label="" name="name">
                  ชื่อผู้ใช้
                  <Input
                    className="mt-2"
                    value={isData?.customerName}
                    disabled={loading}
                    readOnly
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item label="" name="amount">
                  จำนวนเงิน
                  <Input
                    disabled={loading}
                    className="mt-2"
                    value={isData?.amount}
                    readOnly
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item label="" name="date">
                  วันที่/เวลา
                  <Input
                    disabled={loading}
                    className="mt-2"
                    value={moment(isData?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss",
                    )}
                    readOnly
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Form>
              <label>
                อัพโหลดสลิป <br />
              </label>
              <Upslip
                handleChangeLoading={this.handleChangeLoading}
                value={isData}
                fetchData={fetchData}
              />
            </>
          )}
        </Modal>
      </>
    );
  }
}

//ReplyTicketModel
export class ReplyTicketModel extends React.Component {
  state = {
    loading: false,
  };
  handleChangeLoading = (_isLoad) => {
    this.setState({ loading: _isLoad });
  };
  render() {
    const { show, handleClose, isData, t } = this.props; // fetchData
    // const { loading } = this.state;

    return (
      <>
        <Modal
          width={650}
          maskClosable={false}
          closable={false}
          open={show}
          title={<>{t("Reply Ticket")}</>}
          style={{ top: 20 }}
          footer={[<Button onClick={handleClose}>{t("close")}</Button>]}
        >
          {!isData ? (
            <>
              <Empty />
            </>
          ) : (
            <></>
          )}
        </Modal>
      </>
    );
  }
}

//DetialTicketModel
export class DetialTicketModel extends React.Component {
  state = {
    loading: false,
  };
  handleChangeLoading = (_isLoad) => {
    this.setState({ loading: _isLoad });
  };
  render() {
    const { show, handleClose, isData, t } = this.props; // fetchData
    // const { loading } = this.state;

    return (
      <>
        <Modal
          width={650}
          maskClosable={false}
          closable={false}
          open={show}
          title={<>{t("Detial Ticket")}</>}
          style={{ top: 20 }}
          footer={[<Button onClick={handleClose}>{t("close")}</Button>]}
        >
          {!isData ? (
            <>
              <Empty />
            </>
          ) : (
            <></>
          )}
        </Modal>
      </>
    );
  }
}
